/**
 * Created by Ning Jiang on 11/24/2016.
 */
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";


export class TractorBeamSoundConfig implements ISoundConfig {

    public static instance:TractorBeamSoundConfig = new TractorBeamSoundConfig();
    AS_WIN:string="asWin";
    AS_WIN_BIG:string="asWinBig";
    MAIN_GAME_AMBIANCE:string = "background-music-main";
    FREESPIN_AMBIANCE:string = "background-music-fs";


    WIN_TINY:string = "winTiny";
    WIN_SMALL:string = "winSmall";
    WIN_MEDIUM:string = "winMedium";
    WIN_LARGE:string = "winLarge";

    COUNT_UP_LOOP:string = "countup";
    COUNT_UP_END:string = "countupEnds";

    ANTICIPATION:string = "anticipation";
    ANTICIPATION_FAIL:string = "anticipationFail";

    SCATTER_ATTENTION:string = "scatter";
    SCATTER_WIN:string = "scatterWin";

    BIG_WIN:string = "bigwin";
    BIG_WIN_ENDS_1:string = "bigwinEnds1";
    BIG_WIN_ENDS_2:string = "bigwinEnds2";
    BIG_WIN_ENDS_3:string = "bigwinEnds3";
    BIG_WIN_START:string = "bigwinStart";

    BEAM_UP:string = "beamUp";

    RANDOM_FEATURE:string = "randomFeature";

    FS_INTRO:string = "fsIntro";
    FS_WIN_REEL5 = "fsWinReel5Landing";
    FS_OUTRO:string = "fsOutro";
    FS_PLUS_ONE_1:string = "fsPlusOne1";
    FS_PLUS_ONE_2:string = "fsPlusOne2";
    FS_PLUS_ONE_3:string = "fsPlusOne3";

    REELS_SPINNING_START_ON_SPIN_START:string = "wheels-spinning";
    REELS_SPINNING_STOP_DELAY:number = 50;
    REELS_DEFAULT_BOUNCE:string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];

    constructor() {
        if(TractorBeamSoundConfig.instance) {
            throw new Error("TractorBeamSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}
